import { IntlProvider } from 'react-intl';
import { ApolloProvider } from '@apollo/client/react';
import { ToastContainer } from 'react-toastify';
import ToastCloseButton from './components/common/ToastCloseButton';
import { AppContextProvider } from './contexts/AppContext';
import settings from './config/settings';
import i18nMessages from './i18n';
import RootRouter from './router/RootRouter';
import startup from './startup';
import apolloClient from './graphql/apollo';
import 'normalize.css';
import 'rc-tooltip/assets/bootstrap_white.css';
import './styles/index.scss';

startup();

// Without a locale (no REACT_APP_DEFAULT_LOCALE) react-intl falls back to its default locale; it
// treats '' as it treated undefined.
const locale = window?.localStorage?.getItem('language') || settings.defaultLocale || '';

const App = () => (
  <ApolloProvider client={apolloClient}>
    <IntlProvider locale={locale} messages={i18nMessages[locale]}>
      <AppContextProvider locale={locale}>
        <RootRouter />
      </AppContextProvider>
    </IntlProvider>
    {/* react-toastify 11 injects its CSS. The props (and styles/toastify.scss) keep the toasts of
        react-toastify 5: coloured background without an icon, its close glyph, closed by a click,
        draggable with the mouse too. */}
    {/* Bug: the container is outside IntlProvider, so a toast whose content is a
        <FormattedMessage> (the "no server response" toasts of the calculators) throws "could not
        find required intl object" when it renders. */}
    <ToastContainer
      theme="colored"
      icon={false}
      closeButton={ToastCloseButton}
      closeOnClick
      draggable
    />
  </ApolloProvider>
);

export default App;
